<template>
  <div
    class="border-muted-400 absolute left-1/2 z-40 w-screen -translate-x-1/2 border-t border-dashed"
  />
</template>
